import { SvgIconProps } from '@mui/material/SvgIcon';

export interface CustomSvgIconProps extends SvgIconProps {
  toggle?: boolean;
}

export interface SvgIconToggleColor {
  highlighted: string;
  background: string;
}

export enum ToggleColorType {
  highlighted,
  background,
}
